import styled from "styled-components";

export const ProjectStyle = styled.section`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    width: 100%;
    height: 543.36px;
    background-color: white;
    @media (max-width: 768px) {
        margin-top: 0px;       
        margin-bottom: 500px;     
    }
    
    ul {
        display: flex;
        flex-direction: row;
        list-style-type: none;
        height: 415px;
        @media (max-width: 768px) {
            flex-direction: column;       
            margin-left: -3px;
        }
    }

    li {
        width: 348px;
        margin: auto;
        display: flex;
        align-items: center;
        flex-direction: column;
        & img {
            width: 160px;
            height: 160px;
        }
        & h4 {
            text-transform: uppercase;
            text-align: center;
        }
        & p {
            text-align: center;
        }
    }
`